/* Option pills (snippets/option-pills.liquid): keep each pill's subline and corner
   "Sale" flag on the variant it would select given the OTHER options currently chosen.
   The group's JSON ([{o: [options...], w: "45g", s: 1}]) is written by Liquid; this
   re-reads it on the on:variant:change event every product hero dispatches. Idempotent: the sections load
   this once, but a second load is harmless. */
(function () {
  if (window.__optionPillsInit) return;
  window.__optionPillsInit = true;

  function refresh(group, selected) {
    var blob = group.querySelector('[data-opt-pill-map]');
    if (!blob) return;
    var map;
    try { map = JSON.parse(blob.textContent || '[]'); } catch (e) { return; }
    var holder = group.closest('[data-option-index]');
    var idx = holder ? parseInt(holder.dataset.optionIndex, 10) : NaN;
    if (isNaN(idx)) return;
    group.querySelectorAll('[data-option-value]').forEach(function (btn) {
      var value = btn.dataset.optionValue;
      var hit = null, first = null, anySale = false;
      for (var i = 0; i < map.length; i++) {
        var o = map[i].o || [];
        if (o[idx] !== value) continue;
        if (!first) first = map[i];
        if (map[i].s === 1) anySale = true;
        var ok = true;
        for (var k = 0; k < o.length; k++) {
          if (k !== idx && o[k] !== selected[k]) { ok = false; break; }
        }
        if (ok) hit = map[i];
      }
      /* Subline: exact variant, else the first carrying the value. */
      var sub = btn.querySelector('[data-opt-pill-sub]');
      if (sub) {
        var entry = hit || first;
        var text = entry && entry.w ? entry.w : '';
        if (text && text.replace(/\s+/g, '').toLowerCase() === String(value).replace(/\s+/g, '').toLowerCase()) text = '';
        sub.textContent = text;
        sub.hidden = !text;
      }
      /* Sale flag: any variant carrying this value, whatever colour is selected. */
      var flag = btn.querySelector('[data-opt-pill-sale]');
      if (flag) flag.hidden = !anySale || group.hasAttribute('data-opt-pills-all-sale');
    });
  }

  document.addEventListener('on:variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (!v || !v.options) return;
    document.querySelectorAll('[data-opt-pills]').forEach(function (g) { refresh(g, v.options); });
  });
})();
